import { render, staticRenderFns } from "./CreateMusic.vue?vue&type=template&id=4ab80bb0&scoped=true"
import script from "./CreateMusic.vue?vue&type=script&lang=js"
export * from "./CreateMusic.vue?vue&type=script&lang=js"
import style0 from "./CreateMusic.vue?vue&type=style&index=0&id=4ab80bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab80bb0",
  null
  
)

export default component.exports